import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TravelInformation } from 'app/interfaces/journey-management/journey-management-object.interface';
import * as moment from 'moment';
import * as short from 'short-uuid';

@Component({
    selector: 'travel-dialog.component',
    templateUrl: './travel-dialog.component.html',
    styleUrls: [
        './travel-dialog.component.css'
    ],
    encapsulation: ViewEncapsulation.None,
})
export class TravelDialogComponent {
    dialogTitle: string;
    travelInfoForm: FormGroup;
    minDate = moment().toDate();

    constructor(public dialogRef: MatDialogRef<TravelDialogComponent>, private matSnackBar: MatSnackBar, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data?: TravelInformation) {
        this.dialogTitle = data ? 'Update Travel Information' : 'Add Travel Information';
        this.travelInfoForm = this.formBuilder.group({
            key: [short.generate()],
            date: [moment(), Validators.required],
            flightNumber: ['', Validators.required],
            timeETA: [''],
            timeETD: [''],
            protocolArrival: [false],
            protocolDeparture: [false],
            flightOrDetails: [''],
            accommodation: [''],
            linkedPassengers: [[]],
        });

        
        if (this.data) {
            this.travelInfoForm.patchValue(this.data);
            this.travelInfoForm.get('date').touched;
            if (this.travelInfoForm.get('timeETA').value == '') {
                this.travelInfoForm.get('timeETA').disable();  
            }
            if (this.travelInfoForm.get('timeETD').value == '') {
                this.travelInfoForm.get('timeETD').disable();
            }
        } else {
            this.travelInfoForm.get('timeETA').disable();
            this.travelInfoForm.get('timeETD').disable();
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.travelInfoForm.valid) {
            this.dialogRef.close(this.travelInfoForm);
        } else {
            this.travelInfoForm.markAllAsTouched();
            this.openSnackBar('Required fields missing');
        }
    }

    private openSnackBar(message: string, action?: string) {
        this.matSnackBar.open(message, action, {
            duration: 2000,
        });
    }

    onTravelTimeChange(event: any) {
        const timeInput = event.target.value;
        const hoursMinutes = timeInput.split(':');

        if (this.travelInfoForm.get('protocolArrival').value) {
            this.travelInfoForm.get('timeETA').setValue(event.target.value, { emitEvent: false });
        }
        else if (this.travelInfoForm.get('protocolDeparture').value) {
            this.travelInfoForm.get('timeETD').setValue(event.target.value, { emitEvent: false });
        }

        if (this.travelInfoForm.get('date').valid) {
            const currentDate = moment(this.travelInfoForm.get('date').value);

            currentDate.set({ hour: parseInt(hoursMinutes[0]), minute: parseInt(hoursMinutes[1]) });

            this.travelInfoForm.get('date').setValue(currentDate.toDate(), { emitEvent: false });
        }
    }

    onProtocolChange(event: MatCheckboxChange, protocol: 'arrival' | 'departure') {
        const travelCtrl = this.travelInfoForm
        if (protocol === 'arrival') {
            if (event.checked) {
                travelCtrl.get('timeETA').enable();
                travelCtrl.get('timeETD').reset();
                travelCtrl.get('timeETD').disable();
                travelCtrl.get('protocolDeparture').setValue(false);
            }
            else {
                travelCtrl.get('timeETA').disable();
                travelCtrl.get('timeETA').reset();
            }
        }
        else if (protocol === 'departure') {
            if (event.checked) {
                travelCtrl.get('timeETD').enable();
                travelCtrl.get('timeETA').reset();
                travelCtrl.get('timeETA').disable();
                travelCtrl.get('protocolArrival').setValue(false);
            }
            else {
                travelCtrl.get('timeETD').disable();
                travelCtrl.get('timeETD').reset();
            }
        }
    }

    onTravelDateChange(event: any) {
        const travelCtrl = this.travelInfoForm

        if (travelCtrl.get('protocolArrival').value) {
            const hoursMinutes = travelCtrl.get('timeETA').value.split(':');

            const currentDate = moment(event.value);

            currentDate.set({ hour: parseInt(hoursMinutes[0]), minute: parseInt(hoursMinutes[1]) });

            travelCtrl.get('date').setValue(currentDate.toDate(), { emitEvent: false });
        }
        else if (travelCtrl.get('protocolDeparture').value) {
            const hoursMinutes = travelCtrl.get('timeETD').value.split(':');

            const currentDate = moment(event.value);

            currentDate.set({ hour: parseInt(hoursMinutes[0]), minute: parseInt(hoursMinutes[1]) });

            travelCtrl.get('date').setValue(currentDate.toDate(), { emitEvent: false });
        }
        else {
            travelCtrl.get('date').setValue(event.value, { emitEvent: false });
        }
    }

}